import React, { useState, useEffect } from "react";
import { MdOutlineClose } from "react-icons/md";
import {
  imgOne,
  imgTwo,
  imgThree,
  // imgFour,
  imgFive,
  // imgSix,
  imgSeven,
  imgEight,
} from "../../assets/index";

const PrimeGallery = () => {
  let [boxImage, setBoxImage] = useState("");
  useEffect(() => {
    let popupBtn = document.querySelectorAll(".popup");
    let popupBtnArr = Array.from(popupBtn);
    let box = document.querySelector(".box");
    let closeBtn = document.querySelector(".closeBtn");
    let imgArea = document.querySelector(".imgArea");

    closeBtn.addEventListener("click", () => {
      box.style.display = "none";
    });

    document.addEventListener("mousedown", (e) => {
      if (imgArea.contains(e.target)) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
      }
    });

    popupBtnArr.map((item) =>
      item.addEventListener("click", (e) => {
        box.style.display = "block";
        box.style.transition = "all ease-in-out .4s";
        setBoxImage(e.target.src);
      })
    );
  }, []);
  return (
    <div className="w-full h-auto pt-20">
      <div className="flex flex-col items-center">
        <h1 className="text-6xl font-titleFont font-bold text-primeColor">
          Gallery
        </h1>
        <span className="w-32 h-1 mt-2 bg-primeColor inline-block"></span>
      </div>
      <div className="w-full h-full xl:h-[700px] mx-auto px-2 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-2 place-content-center mt-10 xl:mt-0">
        <div className="w-full h-[600px] flex flex-col gap-2">
          <div className="w-full h-1/2 relative group popup cursor-pointer">
            <img
              className="w-full h-full object-cover"
              src={imgThree}
              alt="imgOne"
            />
          </div>
          <div className="w-full h-1/2 relative group popup cursor-pointer">
            <img
              className="w-full h-full object-cover"
              src={imgTwo}
              alt="imgOne"
            />
          </div>
        </div>
        <div className="w-full h-[600px] relative group popup cursor-pointer">
          <img
            className="w-full h-full object-cover"
            src={imgOne}
            alt="imgThree"
          />
        </div>
        <div className="w-full h-auto md:h-[600px] md:col-span-2 flex flex-col gap-2">
          <div className=" w-full h-2/3 md:h-1/2 flex flex-col md:flex-row gap-2">
            <div className="relative group popup cursor-pointer">
              <img
                className="w-full h-full object-cover"
                src={imgEight}
                alt="imgFour"
              />
            </div>
            <div className="relative group popup cursor-pointer">
              <img
                className="w-full h-full object-cover"
                src={imgFive}
                alt="imgFive"
              />
            </div>
          </div>
          <div className="w-full h-1/3 md:h-1/2 relative group popup cursor-pointer">
            <img
              className="w-full h-full object-cover"
              src={imgSeven}
              alt="imgSix"
            />
            {/* <Link to="/products/1">
            <button className="absolute uppercase top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white text-green-600 group-hover:bg-gray-900 group-hover:text-white px-8 py-2 text-base tracking-wide font-semibold border-[3px] border-transparent group-hover:border-green-600 duration-300">
              Exceptional
            </button>
          </Link> */}
          </div>
        </div>
      </div>

      <div className="fixed top-0 left-0 right-0 z-50 box hidden">
        <div className="flex items-center justify-center w-full h-screen bg-black bg-opacity-80">
          <div className="w-[80%] h-[40%] md:h-[80%] relative">
            <button className="p-2 text-xl font-semibold tracking-wide bg-red-500 hover:bg-red-700 duration-300 text-white rounded-lg absolute top-0 -right-12 xl:-right-16 closeBtn">
              <MdOutlineClose className="w-6 h-6" />
            </button>
            <img
              className="w-full h-full rounded-2xl object-cover imgArea"
              src={boxImage}
              alt="Images"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrimeGallery;
